<template>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="emitCancelEvent(location_index, modal_id)"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title">拠点変更</h4>
      </div>
      <div class="modal-note">
        変更内容を反映するには「変更」ボタンを押して、この画面が閉じた後のページ下部にある「変更を適用」を押してください。
      </div>
      <div class="modal-body">
        <div class="form-horizontal">
          <div class="form-group">
            <label class="col-xs-3 control-label">状態</label>
            <div class="col-xs-9">
              <div
                class="m-t-xs"
                :id="'modify_location_status_' + location_index"
              >
                <template v-for="(v, k) in options.status">
                  <label
                    class="m-r-md"
                    :key="`status-label-${k}`"
                    :for="'location_status_' + k + '_' +location_index"
                  >
                    <input
                      type="radio"
                      v-model="location.location_status"
                      name="location_status"
                      :value="k"
                      :key="`status-${k}`"
                      :id="'location_status_' + k + '_' +location_index"
                    />{{ v }}
                  </label>
                </template>
              </div>
            </div>
          </div>
          <hr class="hr-line-dashed" />
          <div class="form-group">
            <label class="col-xs-3 control-label">拠点名</label>
            <div class="col-xs-9">
              <input
                type="text"
                name="location_name"
                placeholder="例）本社、◯◯支店など"
                class="form-control"
                maxlength="40"
                v-model="location.location_name"
              />
            </div>
          </div>
          <hr class="hr-line-dashed" />
          <div class="form-group">
            <label class="col-xs-3 control-label">所在地</label>
            <div class="col-xs-4">
              <div class="input-group">
                <span class="input-group-addon">〒</span>
                <input
                  type="text"
                  name="zip"
                  placeholder="例）123-4567"
                  class="form-control"
                  v-model="location.zip"
                  maxlength="8"
                />
              </div>
            </div>
            <div class="col-xs-5">
              <select name="pref" class="form-control" v-model="location.pref">
                <option
                  v-for="(v, i) in options.pref"
                  v-bind:value="i"
                  :key="i"
                >
                  {{ v }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-9 col-xs-offset-3">
              <input
                type="text"
                name="address"
                placeholder="市区町村・番地・ビル名"
                class="form-control"
                v-model="location.address"
                maxlength="100"
              />
            </div>
          </div>
          <hr class="hr-line-dashed" />
          <div class="form-group">
            <label class="col-xs-3 control-label">TEL</label>
            <div class="col-xs-9">
              <input
                type="text"
                name="tel"
                placeholder="例）123-456-7890"
                class="form-control"
                v-model="location.tel"
                maxlength="40"
              />
            </div>
          </div>
          <hr class="hr-line-dashed" />
          <div class="form-group">
            <label class="col-xs-3 control-label">FAX</label>
            <div class="col-xs-9">
              <input
                type="text"
                name="fax"
                placeholder="例）123-456-7890"
                class="form-control"
                v-model="location.fax"
                maxlength="40"
              />
            </div>
          </div>
          <hr class="hr-line-dashed" />
          <div class="form-group">
            <label class="col-xs-3 control-label">営業時間</label>
            <div class="col-xs-9">
              <input
                type="text"
                name="business_hours"
                placeholder="例）平日9:00-18:00（土日・祝休み）"
                class="form-control"
                v-model="location.business_hours"
                maxlength="100"
              />
              <p class="form_note m-t-sm m-b-none">25文字まで</p>
            </div>
          </div>
          <hr class="hr-line-dashed" />
          <div class="form-group">
            <label class="col-xs-3 control-label">アクセス情報</label>
            <div class="col-xs-9">
              <textarea
                name="access"
                class="form-control"
                v-model="location.access"
              ></textarea>
              <p class="form_note m-t-sm">
                最寄り駅等から所在地への道順を記載してください。 500文字まで
              </p>
            </div>
          </div>
          <hr class="hr-line-dashed" />
          <div class="form-group">
            <label class="col-xs-3 control-label">Googleマップ</label>
            <div class="col-xs-9">
              <div class="m-t-xs" :id="'modify_map_type_' + location_index">
                <template v-for="(v, k) in options.google_map">
                  <label
                    class="m-r-md"
                    :key="`google_map-label-${k}`"
                    :for="'map_type_' + k + '_' +location_index"
                  >
                    <input
                      type="radio"
                      v-model="location.map_type"
                      name="map_type"
                      :value="k"
                      :key="`map-${k}`"
                      :id="'map_type_' + k + '_' +location_index"
                    />{{ v }}
                  </label>
                </template>
              </div>
              <p class="help-block m-t-sm" v-if="location.map_type == 2">
                <a href="https://www.google.co.jp/maps/" target="_blank"
                  >Googleマップ</a
                >から取得した
                <strong>リンクURL</strong> を以下に入力してください。
              </p>
              <p class="help-block m-t-sm" v-if="location.map_type == 3">
                <a href="https://www.google.co.jp/maps/" target="_blank"
                  >Googleマップ</a
                >から取得した
                <strong>埋め込みコード</strong> を以下に入力してください。
              </p>
              <input
                type="text"
                name="google_map_url"
                v-model="location.google_map_url"
                v-if="location.map_type == 2"
                placeholder="例）https://goo.gl/maps/〜"
                class="form-control"
                maxlength="1000"
              />
              <input
                type="text"
                name="google_map_embed"
                v-model="location.google_map_embed"
                v-if="location.map_type == 3"
                placeholder="例）<iframe src=https://www.google.com/maps/〜"
                class="form-control"
                maxlength="1000"
              />
              <div
                class="googlemap_preview m-t-sm"
                v-show="location.google_map_embed && location.map_type == 3"
              >
                <div
                  class="map-content__image longurl"
                  v-html="location.google_map_embed"
                ></div>
                <p class="form_note m-t-sm">
                  正しく表示されない場合は、Googleマップの埋め込みコードを再度ご確認ください。
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default btn-settings btn-lg"
              @click="emitCancelEvent(location_index, modal_id)"
            >
              キャンセル
            </button>
            <button
              type="button"
              class="btn btn-primary btn-settings btn-lg"
              id="approval_register"
              @click="emitSaveEvent(location_index, modal_id)"
            >
              変更
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.preline {
  white-space: pre-line;
}
textarea {
  resize: vertical;
}
</style>
<script>
export default {
  props: ["options", "location", "location_index", "modal_id"],

  methods: {
    emitCancelEvent(location_index, modal_id) {
      this.$emit("change-cancel", {
        location_index: location_index,
        modal_id: modal_id,
      });
    },
    emitSaveEvent(location_index, modal_id) {
      this.$emit("change", {
        location_index: location_index,
        modal_id: modal_id,
      });
    },
  },
};
</script>

